import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import DatePicker from 'react-datepicker';
import { setHours, setMinutes } from 'date-fns';
import ru from 'date-fns/locale/ru';
import moment from 'moment';

import "react-datepicker/dist/react-datepicker.css";
import "./react-datepicker.custom.scss";
import { InputField } from '../input-field/input-field';

interface DateInputProps extends Record<string, any> {
	onChange?: (value: string) => void;
	name: string
	mask: string
	receptionTime?: any
  dateFormat: string;
  autoComplete?: string;
  placeholderText?: string;
  theme?: string;
}

export const DateInput:React.FC<DateInputProps> = (props:DateInputProps) => {
	const [ value, setValue ] = useState<Date | null>(null);
	const { onChange, mask, name, ...rest } = props;

	const handleChange = (date:Date) => {
		setValue(date);

		let value = "";
		if (name == 'date') value = moment(date).format('DD.MM.YYYY');
		if (name == 'time') value = moment(date).format('HH:mm');

		onChange && onChange(value);
	};

	const getTime = (() => {
		let minH = 9, minM = 0, maxH = 20, maxM = 0;
		const { receptionTime } = props;

		if (receptionTime) {
			const regExp = /(?<minH>\d{1,2}):(?<minM>\d{1,2})-(?<maxH>\d{1,2}):(?<maxM>\d{1,2})/;
			({ minH, minM, maxH, maxM } = receptionTime.match(regExp).groups);
		}

		return {
			min: setHours(setMinutes(new Date(), minM), minH),
			max: setHours(setMinutes(new Date(), maxM), maxH)
		}
	})();

	return (<InputField name={name} mask={mask} value={value}>
		<DatePicker
			onChange={handleChange} 
			selected={value}
			locale={ru}
			minDate={new Date()}
			minTime={getTime.min}
			maxTime={getTime.max}
			fixedHeight
			popperPlacement="top-middle"
			customInput={
				<InputMask autoComplete='off' mask={mask} maskChar={null} />
			}
			{...rest} 
		/>
	</InputField>);
}